module.exports = __webpack_public_path__ + "img/红-选中@3x.edcc0e30.png";